export const myProjects = [
  {
    projectTitle: "controling_localStorage",
    category: ["js"],
    imgPath: "./images/contrsling_localStorage.png",
    gitHubPath: "https://github.com/HaidarDalla/Controling-LocalStorage.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/902172658334729/",
    id: 1,
  },
  {
    projectTitle: "HTML_CSS_JS_Pure",
    category: ["js"],
    imgPath: "./images/HTML_CSS_JS_bure.png",
    gitHubPath: "https://github.com/HaidarDalla/HTML_CSS_JS-Pure-Project.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/1898108127307184/",
    id: 2,
  },
  {
    projectTitle: "HTML_CSS_JS_Sroll",
    category: ["js"],
    imgPath: "./images/HTML_CSS_JS_Sroll.png",
    gitHubPath: "https://github.com/HaidarDalla/Scroll.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/3596477140627547/",
    id: 3,
  },
  {
    projectTitle: "HTML_CSS_Pure_One",
    category: ["css"],
    imgPath: "./images/HTML_CSS_Pure_One .png",
    gitHubPath: "https://github.com/HaidarDalla/HTML_And_CSS_Design_One.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/820099600183779/",
    id: 4,
  },
  {
    projectTitle: "HTML_CSS_Pure_Three",
    category: ["css"],
    imgPath: "./images/HTML_CSS_Pure_Three.png",
    gitHubPath: "https://github.com/HaidarDalla/HTML_And_CSS_Design_Three.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/984180399878416/",
    id: 5,
  },

  {
    projectTitle: "HTML_CSS_Pure_Two",
    category: ["css"],
    imgPath: "./images/HTML_CSS_Pure_Two.png",
    gitHubPath: "https://github.com/HaidarDalla/HTML_And_CSS_Design_Two.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/820103289740007/",
    id: 6,
  },
  {
    projectTitle: "To_Do_List",
    category: ["js"],
    imgPath: "./images/To_Do_List.png",
    gitHubPath: "https://github.com/HaidarDalla/List-Of-Tasks.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/998361155173760/",
    id: 7,
  },
  {
    projectTitle: "CRUD Project",
    category: ["react"],
    imgPath: "./images/ReactApp.png",
    gitHubPath:
      "https://github.com/HaidarDalla/React-Login-page-new-user-and-dashboard.git",
    facebookVedio:
      "https://www.facebook.com/61560471730015/videos/484308174125106/",
    id: 8,
  },
  {
    projectTitle: "usePopcorn",
    category: ["react"],
    imgPath: "./images/2.png",
    gitHubPath:
      "#",
    facebookVedio:
      "#",
    id: 9,
  },
];
